import React, { FC, useCallback } from 'react';
import { RootState } from 'src/store';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import SettingsBlock from '../SettingsBlock';
import { alpha, Box, Stack, SxProps, Typography } from '@mui/material';
import { formFields } from './formData';
import Form from 'src/components/Form';
import { FieldValues } from 'react-hook-form';
import ChipButton from 'src/components/ChipButton';
import ConfirmIcon from '@mui/icons-material/CheckOutlined';
import { FORM_MIN_WIDTH } from './utils';

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;

const SettingsProfile: FC<Props> = ({ onSaveProfile }) => {
  const [isSaveDisabled, setIsSaveDisabled] = React.useState(false);
  const formRef = React.useRef<HTMLFormElement>(null);
  const onFormSubmit = useCallback(() => {
    if (formRef.current) {
      formRef.current.requestSubmit();
    }
  }, [formRef.current]);

  const formStyles: SxProps = {
    minWidth: FORM_MIN_WIDTH,
    maxWidth: FORM_MIN_WIDTH,
  };
  console.log({ isSaveDisabled });

  return (
    <Stack
      direction="column"
      flex={1}
      marginInlineStart={2}
      sx={{ direction: 'rtl' }}
    >
      <SettingsBlock title="מידע אישי">
        {/* <Box display="flex" flexDirection="column" gap={2.5}>
          {AccountSettings.map((setting) => (
            <SettingBlock key={setting.id} {...setting} />
          ))}
        </Box> */}
        <Box display="flex" flexDirection="column" gap={1.5} maxWidth="70%">
          <Typography fontWeight={500} fontSize={18} lineHeight={1}>
            בחר בפילטרים שאותם המערכת תייצר דוח אוטומטי בחר בפילטרים שאותם
            המערכת תייצר דוח אוטומטי בחר בפילטרים שאותם המערכת תייצר דוח אוטומטי
            בחר בפילטרים שאותם המערכת תייצר דוח אוטומטי בחר בפילטרים שאותם
            בפילטרים שאותם המערכת תייצר דוח אוטומטי
          </Typography>
          <Form
            ref={formRef}
            fields={formFields}
            isWithLabelIndent={false}
            onSubmit={onSaveProfile}
            styles={formStyles}
            onIsDirtyChange={setIsSaveDisabled}
          />
          <ChipButton
            color="primary"
            sx={{
              padding: ({ spacing }) => spacing(0.5, 2, 0.5, 1.25),
              fontWeight: 600,
              width: 'fit-content',
              background: ({ palette }) =>
                alpha(palette.primaryLight80 ?? '', 0.25),
              '&:hover': {
                background: ({ palette }) =>
                  alpha(palette.primaryLight80 ?? '', 0.25),
              },
            }}
            endIcon={
              <ConfirmIcon
                sx={{
                  fontSize: 18,
                }}
              />
            }
            onClick={onFormSubmit}
            disabled={!isSaveDisabled}
          >
            שמירה
          </ChipButton>
        </Box>
      </SettingsBlock>
    </Stack>
  );
};

const mapStateToProps = (state: RootState) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onSaveProfile: (data: FieldValues) => {
    // dispatch(receiptsSetControlFilters(payload))
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SettingsProfile);
